import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Header from "components/Header/index";
import Sidebar from "containers/SideNav/index";
import Footer from "components/Footer";
import Tour from "../components/Tour/index";
import {
    BASE_URL_OSLOG,
    ABOVE_THE_HEADER,
    BELOW_THE_HEADER,
    COLLAPSED_DRAWER,
    FIXED_DRAWER,
    HORIZONTAL_NAVIGATION,
} from "constants/ActionTypes";
import { isIOS, isMobile } from "react-device-detect";
import asyncComponent from "../util/asyncComponent";
import TopNav from "components/TopNav";
import {
    NotificationContainer,
    NotificationManager,
} from "react-notifications";

import MasterData from "./routes/MasterData";
// import ControlMonitoring from './routes/ControlMonitoring';
// import Finance from './routes/Finance';
// import Dashboard from './routes/Dashboard';
import VehicleMaintenance from "./routes/VehicleMaintenance";
import Setting from "./routes/Setting";
import OTA from "./routes/OTA";
import MasterDriver from "./routes/MasterDriver";
import MasterVehicle from "./routes/MasterVehicle";
import Osc from "./routes/Osc";
import axios from "axios";
// import withGracefulUnmount from 'react-graceful-unmount'

const PACKAGE_NAME = localStorage.getItem("package");

class App extends React.Component {
    state = {
        dataEmbedd: false,
    };

    // handleRemoveSessionStorage = () => {
    //   sessionStorage.removeItem('user_id');
    //   sessionStorage.removeItem('apiKey');
    //   sessionStorage.removeItem('rolename');
    //   sessionStorage.removeItem('name');
    //   sessionStorage.removeItem('menu_user');
    //   sessionStorage.removeItem('companyId');
    //   sessionStorage.clear();
    // }

    handleRemoveLocalStorage = () => {
        localStorage.removeItem("user_id");
        localStorage.removeItem("apiKey");
        localStorage.removeItem("rolename");
        localStorage.removeItem("name");
        localStorage.removeItem("menu_user");
        localStorage.removeItem("companyId");
        localStorage.clear();
    };

    onUnload = (e) => {
        // the method that will be used for both add and remove event
        console.log("akses onUnload");
        console.log("event", e);
        e.preventDefault();
        e.returnValue =
            "Are you sure you want to leave this page?  You will lose any unsaved data.";
    };

    onUnloadLogout = (e) => {
        // the method that will be used for both add and remove event
        console.log("akses onUnloadLogout");
        console.log("event onUnloadLogout", e);
        e.preventDefault();
        e.returnValue =
            "Are you sure you want to leave this page?  You will lose any unsaved data.";
        this.handleLogout();
    };

    componentDidMount() {
        // console.log("window.performance", window.performance)
        // if (window.performance) {
        //   if (performance.navigation.type == 1) {
        //     alert( "This page is reloaded" );
        //   } else {
        //     window.addEventListener("beforeunload", this.onUnload);
        //   }
        // }
        const { search } = this.props.location;
        const params = new URLSearchParams(search);
        const parsed = params.get("embedd");
        console.log('param is :', parsed)
        if (parsed === "true") {
            this.setState({ dataEmbedd: true });
        } else if (parsed === undefined) {
            //      // console.log('no params in this url')
            this.setState({ dataEmbedd: false });
        }
    }

    // componentWillUnmount() {
    //   window.removeEventListener("beforeunload", this.onUnload);
    //   this.handleLogout();
    // }

    handleLogout = async () => {
        const URL = `${BASE_URL_OSLOG}/app/logout`;
        await axios({
            headers: {
                Accept: "application/json",
            },
            method: "get",
            url: URL,
            withCredentials: true,
        })
            .then((response) => response)
            .catch((error) => error.response);

        this.handleRemoveLocalStorage();

        // if (window.location.hostname === HOSTNAME_OSLOG) {
        //     //oslog
        //     window.location = BASE_URL_OSLOG + "/v5/";
        //     //advotics
        //     // window.location = BASE_URL_OSLOG + "/advotics/";
        // } else {
        //     window.location = window.location.origin;
        // }

        window.location = window.location.origin;
    };

    render() {
        const { match, drawerType, navigationStyle, horizontalNavPosition } =
            this.props;
        const drawerStyle = drawerType.includes(FIXED_DRAWER)
            ? "fixed-drawer"
            : drawerType.includes(COLLAPSED_DRAWER)
                ? "collapsible-drawer"
                : "mini-drawer";

        //set default height and overflow for iOS mobile Safari 10+ support.
        if (isIOS && isMobile) {
            document.body.classList.add("ios-mobile-view-height");
        } else if (document.body.classList.contains("ios-mobile-view-height")) {
            document.body.classList.remove("ios-mobile-view-height");
        }

        // console.log(navigationStyle, horizontalNavPosition);
        return (
            <div className={`app-container ${drawerStyle}`}>
                {/* {PACKAGE_NAME == 'Lite' && <Tour {...this.props} />} */}

                <NotificationContainer />
                {this.state.dataEmbedd == true ? <div></div> : <Sidebar />}

                <div className="app-main-container">
                    {this.state.dataEmbedd == true ? (
                        <div></div>
                    ) : (
                        <div
                            id="app-header"
                            className={`app-header ${navigationStyle === HORIZONTAL_NAVIGATION
                                ? "app-header-horizontal"
                                : ""
                                }`}
                        >
                            {navigationStyle === HORIZONTAL_NAVIGATION &&
                                horizontalNavPosition === ABOVE_THE_HEADER && (
                                    <TopNav styleName="app-top-header" />
                                )}
                            <Header />
                            {navigationStyle === HORIZONTAL_NAVIGATION &&
                                horizontalNavPosition === BELOW_THE_HEADER && (
                                    <TopNav />
                                )}
                        </div>
                    )}

                    <main className="app-main-content-wrapper">
                        <div className="app-main-content">
                            <Switch>
                                <Route
                                    path={`${match.url}/dashboard-vehicle`}
                                    component={asyncComponent(() =>
                                        import("./routes/SamplePage")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-menu`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterMenu")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/package-menu`}
                                    component={asyncComponent(() =>
                                        import("./routes/PackageMenu")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/user-management`}
                                    component={asyncComponent(() =>
                                        import("./routes/UserManage")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/profile`}
                                    component={asyncComponent(() =>
                                        import("./routes/Profile")
                                    )}
                                />
                                {/* <Route
                                    path={`${match.url}/config`}
                                    component={asyncComponent(() =>
                                        import("./routes/Pengaturan")
                                    )}
                                /> */}
                                <Route
                                    path={`${match.url}/user`}
                                    component={asyncComponent(() =>
                                        import("./routes/User")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-driver`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterDriver")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-driver-license`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterDriverLicense")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-vehicle`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterVehicle")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/vehicle-type`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterVehicleType")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-vehicle-license`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterVehicleLicense")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-vehicle-status`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterVehicleStatus")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/refresh-token`}
                                    component={asyncComponent(() =>
                                        import("./routes/RefreshToken")
                                    )}
                                />
                                {/* <Route path={`${match.url}/date`}
                  component={asyncComponent(() => import('./routes/Picker/Date'))} />
                <Route path={`${match.url}/date-time`}
                  component={asyncComponent(() => import('./routes/Picker/DateTime'))} />
                <Route path={`${match.url}/dropdown`}
                  component={asyncComponent(() => import('./routes/Dropdown'))} /> */}
                                <Route
                                    path={`${match.url}/dashboard-reminder`}
                                    component={asyncComponent(() =>
                                        import(
                                            "./routes/DashboardReminder/index2"
                                        )
                                    )}
                                />
                                {/* <Route path={`${match.url}/list`}
                  component={asyncComponent(() => import('./routes/List'))} /> */}
                                <Route
                                    path={`${match.url}/dashboard-checkinout`}
                                    component={asyncComponent(() =>
                                        import("./routes/DashboardOsc")
                                    )}
                                />
                                {/* <Route path={`${match.url}/employee-checkinout`}
                  component={asyncComponent(() => import('./routes/DashboardOscEmp'))} /> */}
                                <Route
                                    path={`${match.url}/dashboard-order-management`}
                                    component={asyncComponent(() =>
                                        import(
                                            "./routes/DashboardOrderManagement"
                                        )
                                    )}
                                />
                                <Route
                                    path={`${match.url}/work-order`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterWorkOrder")
                                    )}
                                />
                                <Route
                                    exact
                                    path={`${match.url}/sales-order`}
                                    component={asyncComponent(() =>
                                        import("./routes/SalesOrder")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/sales-order-v1`}
                                    component={asyncComponent(() =>
                                        import("./routes/SalesOrderV1")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/sales-order-hokben`}
                                    component={asyncComponent(() =>
                                        import("./routes/SalesOrderHokben")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/sales-order-kit`}
                                    component={asyncComponent(() =>
                                        import("./routes/SalesOrderKit")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/detail-group`}
                                    component={asyncComponent(() =>
                                        import("./routes/DetailGroup")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/detail-waypoint`}
                                    component={asyncComponent(() =>
                                        import("./routes/DetailWaypoint")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/list-detail-so`}
                                    component={asyncComponent(() =>
                                        import("./routes/ListDetailSo")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/sales-order-paxel`}
                                    component={asyncComponent(() =>
                                        import("./routes/SalesOrderPaxel")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/sales-order-jnt`}
                                    component={asyncComponent(() =>
                                        import("./routes/SalesOrderJ&T")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-inspection-list`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterInspection")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-user`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterUser")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/create-driver-assignment-v2`}
                                    component={asyncComponent(() =>
                                        import("./routes/CreateDriverAssignment")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/order-assignment`}
                                    component={asyncComponent(() =>
                                        import("./routes/OrderAssignment")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/order-assignment-paxel`}
                                    component={asyncComponent(() =>
                                        import("./routes/OrderAssignmentPaxel")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/order-assignment-jnt`}
                                    component={asyncComponent(() =>
                                        import("./routes/OrderAssignmentJ&T")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/monitoring-dispatch`}
                                    component={asyncComponent(() =>
                                        import("./routes/MonitoringDispatch")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/monitoring-dispatch-mab`}
                                    component={asyncComponent(() =>
                                        import("./routes/MonitoringDispatchDipta")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/monitoring-dispatch-dutatrans`}
                                    component={asyncComponent(() =>
                                        import(
                                            "./routes/MonitoringDispatchDuta"
                                        )
                                    )}
                                />
                                <Route
                                    path={`${match.url}/message-bidding`}
                                    component={asyncComponent(() =>
                                        import(
                                            "./routes/MessageBidding"
                                        )
                                    )}
                                />
                                <Route
                                    path={`${match.url}/monitoring-bidding`}
                                    component={asyncComponent(() =>
                                        import(
                                            "./routes/MonitoringBidding"
                                        )
                                    )}
                                />
                                <Route
                                    path={`${match.url}/shipment-v2`}
                                    component={asyncComponent(() =>
                                        import("./routes/ShipmentV2")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-sales`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterSales")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/country`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterCountry")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/area`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterArea")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/measurement`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterMeasurement")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-uom`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterUom")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/pool-group`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterPoolGroup")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/pool`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterPool")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-vendor`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterVendor")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-company`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterCompany")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-security`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterSecurity")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-sensor`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterSensor")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-gps`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterGPS")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-unit-type`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterUnitType")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-recalculate`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportRecalculate")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-product`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterProduct")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/transportation-cost`}
                                    component={asyncComponent(() =>
                                        import("./routes/TransportationCost")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/delivery-cost`}
                                    component={asyncComponent(() =>
                                        import("./routes/DeliveryCost")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-department`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterDepartment")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-geofence`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterGeofence")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-vendor-jnt`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterVendorJNT")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/reshare-log`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReshareLog")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/epoool`}
                                    component={asyncComponent(() =>
                                        import("./routes/EPoool")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-spatial`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportSpatial")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-sensor`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportSensor")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-event`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportEvent")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-summary`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportSummary")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-summary-v2`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportSummaryV2")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-and-monitoring-driver-shipment`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportAndMonitoringDriverShipment")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-summary-v2-utilisasi`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportSummaryV2/ReportSummaryUtilization")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-notification`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterNotification")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/vehicle-disposal`}
                                    component={asyncComponent(() =>
                                        import("./routes/VehicleDisposal")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/vehicle-write-off`}
                                    component={asyncComponent(() =>
                                        import("./routes/VehicleWriteOff")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/gantt`}
                                    component={asyncComponent(() =>
                                        import("./routes/GanttChart")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/vehicle-transfer`}
                                    component={asyncComponent(() =>
                                        import("./routes/VehicleTransfer")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/vehicle-accident`}
                                    component={asyncComponent(() =>
                                        import("./routes/VehicleAccident")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-prices-point`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterPricesPoint")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/top-up`}
                                    component={asyncComponent(() =>
                                        import("./routes/TopUp")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-cost-point`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterCostPoint")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-point`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterPoint")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/service-type`}
                                    component={asyncComponent(() =>
                                        import("./routes/ServiceType")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/service-vehicle`}
                                    component={asyncComponent(() =>
                                        import("./routes/ServiceVehicle")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/service-reminder`}
                                    component={asyncComponent(() =>
                                        import(
                                            "./routes/ServiceReminder/index2"
                                        )
                                    )}
                                />
                                <Route
                                    path={`${match.url}/service-reminder-lite`}
                                    component={asyncComponent(() =>
                                        import(
                                            "./routes/ServiceReminderLite/index2"
                                        )
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-sales-order`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportSalesOrder")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/dashboard-lite`}
                                    component={asyncComponent(() =>
                                        import("./routes/DashboardLite")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-seal`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterSeal")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-seal`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportSeal")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-trip`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportTrip")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/trip-v2`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportV2/ReportTrip")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/Workshop`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterWorkShop")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/register-account`}
                                    component={asyncComponent(() =>
                                        import("./routes/RegisterAccount")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-oschecker`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportOsc")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/excel`}
                                    component={asyncComponent(() =>
                                        import("./routes/XLSX")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/truck-utilization`}
                                    component={asyncComponent(() =>
                                        import("./routes/TruckUtilization")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/truck-working-time`}
                                    component={asyncComponent(() =>
                                        import("./routes/TruckWorkingTime")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/truck-mileage`}
                                    component={asyncComponent(() =>
                                        import("./routes/TruckMileage")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/truck-mileage-route`}
                                    component={asyncComponent(() =>
                                        import("./routes/TruckMileageByRoute")
                                    )}
                                />
                                {/* <Route path={`${match.url}/employee-transfer`}
                  component={asyncComponent(() => import('./routes/EmployeeTransfer'))} />
                <Route path={`${match.url}/employee-pension`}
                  component={asyncComponent(() => import('./routes/EmployeePension'))} />
                <Route path={`${match.url}/employee-resign`}
                  component={asyncComponent(() => import('./routes/EmployeeResign'))} />
                <Route path={`${match.url}/work-accident`}
                  component={asyncComponent(() => import('./routes/EmployeeAccident'))} />
                <Route path={`${match.url}/report-employee`}
                  component={asyncComponent(() => import('./routes/ReportEmployee'))} />
                <Route path={`${match.url}/employee-document`}
                  component={asyncComponent(() => import('./routes/DocumentEmployee/index2'))} /> */}
                                <Route
                                    path={`${match.url}/report-gps-system`}
                                    component={asyncComponent(() =>
                                        import("./routes/GpsReportSystem")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-gps-system-v2`}
                                    component={asyncComponent(() =>
                                        import("./routes/GpsReportSystemV2")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-paxel`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportPaxel")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/register-pod`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterPOD")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/target-ota`}
                                    component={asyncComponent(() =>
                                        import("./routes/TargetOta")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/target-otlotd`}
                                    component={asyncComponent(() =>
                                        import("./routes/TargetOtlOtd")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/master-fuel`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterFuel")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-shipment`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportShipment")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-last-device`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportLastDevice")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-enter-exit`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportEnterExit")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/truck-position`}
                                    component={asyncComponent(() =>
                                        import("./routes/TruckPosition")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/access-map`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterAccessMap")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/history-datadevice`}
                                    component={asyncComponent(() =>
                                        import("./routes/HistoryDataDevice")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/get-datadevice`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterGetDataDevice")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/total-shipment`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportTotalShipment")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/summary-shipment`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportSummaryShipment")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/list-vendor`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportListVendors")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/list-shipment`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportListShipment")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/detail-activity-shipment`}
                                    component={asyncComponent(() =>
                                        import(
                                            "./routes/ReportDetailActivityShipment"
                                        )
                                    )}
                                />
                                <Route
                                    path={`${match.url}/detail-shipment-vehicle`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportShipmentVehicle")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/detail-shipment-driver`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportShipmentDriver")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/result-auto-dispatch`}
                                    component={asyncComponent(() =>
                                        import("./routes/ResultAutoDispatch")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-leading-time`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportLeadingTime")
                                    )}
                                />
                                {/* <Route path={`${match.url}/tracking-map`}
                                       component={asyncComponent(() => import('./routes/Tracking'))}/>
                                */}

                                {/* <Route path={`${match.url}/master-data`} component={MasterData} /> */}
                                {/* <Route path={`${match.url}/control-monitoring`} component={ControlMonitoring} /> */}
                                {/* <Route path={`${match.url}/finance`} component={Finance} />
                <Route path={`${match.url}/dashboard`} component={Dashboard} /> */}
                                <Route
                                    path={`${match.url}/vehicle-maintenance`}
                                    component={VehicleMaintenance}
                                />
                                <Route
                                    path={`${match.url}/setting`}
                                    component={Setting}
                                />
                                <Route
                                    path={`${match.url}/ota`}
                                    component={OTA}
                                />
                                <Route
                                    path={`${match.url}/osc`}
                                    component={Osc}
                                />

                                <Route
                                    path={`${match.url}/dashboard`}
                                    component={asyncComponent(() =>
                                        import("./routes/Embedd")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/dashboardmonitoring`}
                                    component={asyncComponent(() =>
                                        import("./routes/Embedd")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/finance-dashboard`}
                                    component={asyncComponent(() =>
                                        import("./routes/Embedd")
                                    )}
                                />

                                <Route
                                    path={`${match.url}/tracking/mapMonitoring`}
                                    component={asyncComponent(() =>
                                        import("./routes/Embedd")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/ganttchart/ganttChartMonitoring`}
                                    component={asyncComponent(() =>
                                        import("./routes/Embedd")
                                    )}
                                />

                                {/* <Route path={`${match.url}/map`}
                  component={asyncComponent(() => import('./routes/Map'))} /> */}

                                {/* Master data -> Sales Support */}
                                <Route
                                    path={`${match.url}/business-type`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterBusinessType")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/company/list`}
                                    component={asyncComponent(() =>
                                        import(
                                            "./routes/MasterData/routes/SalesSupport/routes/Company"
                                        )
                                    )}
                                />
                                <Route
                                    path={`${match.url}/customer`}
                                    component={asyncComponent(() =>
                                        import("./routes/MasterCustomer")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/customer-point`}
                                    component={asyncComponent(() =>
                                        import("./routes/CustomerPoint")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/group-customer-point`}
                                    component={asyncComponent(() =>
                                        import("./routes/GroupCustomerPoint")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/contract/list`}
                                    component={asyncComponent(() =>
                                        import("./routes/Embedd")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/uom/list`}
                                    component={asyncComponent(() =>
                                        import("./routes/Embedd")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/product/list`}
                                    component={asyncComponent(() =>
                                        import("./routes/Embedd")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/pricing/list`}
                                    component={asyncComponent(() =>
                                        import("./routes/Embedd")
                                    )}
                                />

                                <Route
                                    path={`${match.url}/attach`}
                                    component={asyncComponent(() =>
                                        import("./routes/Embedd")
                                    )}
                                />

                                <Route
                                    path={`${match.url}/maps-monitoring`}
                                    component={asyncComponent(() =>
                                        import("./routes/EmbeddMapMonitoringV2")
                                    )}
                                />

                                <Route
                                    path={`${match.url}/view-monitoring-dispatch`}
                                    component={asyncComponent(() =>
                                        import("./routes/EmbeddViewMonitoringDispatch")
                                    )}
                                />

                                <Route
                                    path={`${match.url}/gantt-monitoring`}
                                    component={asyncComponent(() =>
                                        import("./routes/EmbeddGanttMonitoring")
                                    )}
                                />

                                <Route
                                    path={`${match.url}/alert-notification`}
                                    component={asyncComponent(() =>
                                        import("./routes/AlertNotification")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/alert-notification-docs`}
                                    component={asyncComponent(() =>
                                        import("./routes/AlertNotificationDocs")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/vehicle-status-army`}
                                    component={asyncComponent(() =>
                                        import("./routes/VehicleStatusArmy")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/dashboard-paxel-shipment`}
                                    component={asyncComponent(() =>
                                        import(
                                            "./routes/DashboardPaxelShipment"
                                        )
                                    )}
                                />
                                <Route
                                    path={`${match.url}/dashboard-jnt-shipment`}
                                    component={asyncComponent(() =>
                                        import(
                                            "./routes/DashboardJ&TShipment"
                                        )
                                    )}
                                />
                                <Route
                                    path={`${match.url}/epoool-truck-position`}
                                    component={asyncComponent(() =>
                                        import("./routes/EpooolTruckPosition")
                                    )}
                                />
                                <Route path={`${match.url}/routing-maps`}
                                    component={asyncComponent(() => import('./routes/RoutingMaps'))} />
                                <Route path={`${match.url}/dynamic-status-vehicle`}
                                    component={asyncComponent(() => import('./routes/DynamicStatusVehicle'))} />

                                <Route
                                    path={`${match.url}/history-driver-assignment-v2`}
                                    component={asyncComponent(() =>
                                        import("./routes/HistoryDriverAssignmentV2")
                                    )}
                                />

                                <Route
                                    path={`${match.url}/report-window-time`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportWindowTimePtpn")
                                    )}
                                />

                                <Route
                                    path={`${match.url}/fleetv2`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportFleetV2")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-sensorv2`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportSensorV2")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-driver-v2`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportV2/ReportDriver")
                                        )}
                                />
                                <Route
                                    path={`${match.url}/report-trip-count-v2`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportV2/TripCount")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-exploitation-truck-v2`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportV2/ExploitationTruck")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/target-ota-v2`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportV2/CustomOta/TargetOta")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-ota-v2`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportV2/CustomOta/ReportOta")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/report-ota-by-distance-v2`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportV2/CustomOta/ReportOtaByDistance")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/target-otl-otd-v2`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportV2/CustomOta/TargetOtlOtd")
                                    )}
                                />                               
                                <Route
                                    path={`${match.url}/report-otl-otd-v2`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportV2/CustomOta/ReportOtlOtd")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/customer-group-by-user-login`}
                                    component={asyncComponent(() =>
                                        import("./routes/ReportV2/CustomOta/CustomerGroupByUserLogin")
                                    )}
                                />
                                <Route
                                    path={`${match.url}/404`}
                                    component={asyncComponent(() =>
                                        import("components/Error404")
                                    )}
                                />
                                <Route
                                    component={asyncComponent(() =>
                                        import("components/Error404")
                                    )}
                                />
                            </Switch>
                        </div>
                        {/* <Footer/> */}
                    </main>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ settings }) => {
    const { drawerType, navigationStyle, horizontalNavPosition } = settings;
    return { drawerType, navigationStyle, horizontalNavPosition };
};
export default withRouter(connect(mapStateToProps, {})(App));
// export default withRouter(connect(mapStateToProps, {
// })(withGracefulUnmount(App)));



// WEBPACK FOOTER //
// ./app/index.js